import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  apps: string[];
  loading: Record<string, boolean>;
}

const initialAuthState = {
  accessToken: null,
  refreshToken: null,
  apps: [],
  loading: {},
};

type Actions = {
  reset: () => void;
};

export const authModel = create(
  persist<AuthState & Actions>(
    (set) => ({
      ...initialAuthState,
      reset: () => {
        set({
          ...initialAuthState,
        });
      },
    }),
    {
      name: 'sc-auth-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
